
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[airport]/electric-car",
      function () {
        return require("private-next-pages/[airport]/electric-car/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[airport]/electric-car"])
      });
    }
  